import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  fetchUserAdsenseTransactions,
  clearUserAdsenseTransactions,
} from 'redux/earnings/actions';

import EstimatedEarnings from 'components/dashboard/earn-content/EstimatedEarnings';
import EarningPerDayGraph from 'components/dashboard/earn-content/EarningPerDayGraph';
import UserEarnings from 'components/dashboard/earn-content/UserEarnings';
import EarnDisclaimer from 'components/dashboard/earn-content/EarnDisclaimer';

const EarningsSection = ({
  userId,
  fetchUserAdsenseTransactions,
  clearUserAdsenseTransactions,
  adsenseTransactions,
}) => {

  const [adsenseData, setAdsenseData] = useState({});

  useEffect(() => {
    if (userId) {
      fetchUserAdsenseTransactions(userId);
    }
    return () => clearUserAdsenseTransactions();
  }, [userId]);

  useEffect(() => {
    if (adsenseTransactions) {
      setAdsenseData(adsenseTransactions);
    }
    return () => setAdsenseData({});
  }, [adsenseTransactions]);

  if (!userId) {
    return null;
  }

  const { balance, estimated_earnings, graph_daily_earning } = adsenseData;

  return (
    <>
      {/* Earn disclaimer */}
      <EarnDisclaimer />

      {/* Estimated earnings */}
      <EstimatedEarnings estimatedEarnings={estimated_earnings || {}} balance={balance || 0} />

      {/* Earning per day */}
      <EarningPerDayGraph graphDailyEarning={graph_daily_earning} />

      {/* User earnings */}
      <UserEarnings balance={balance || 0} />
    </>
  );
};

EarningsSection.propTypes = {
  userId: PropTypes.number.isRequired,
  fetchUserAdsenseTransactions: PropTypes.func,
  clearUserAdsenseTransactions: PropTypes.func,
  adsenseTransactions: PropTypes.object,
};
EarningsSection.defaultProps = {
  fetchUserAdsenseTransactions: null,
  clearUserAdsenseTransactions: null,
  adsenseTransactions: null,
};

const mapStateToProps = state => ({
  adsenseTransactions: state.earningsReducer.adsenseTransactions,
  adsenseTransactionsError: state.earningsReducer.adsenseTransactionsError,
});

export default connect(
  mapStateToProps,
  {
    fetchUserAdsenseTransactions,
    clearUserAdsenseTransactions,
  },
)(EarningsSection);
